import React from 'react';
import { Hero } from './components/Hero';
import { GmailReviews } from './components/GmailReviews';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { Opinions } from './components/Opinions';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { ClosingStatement } from './components/ClosingStatement';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { Support } from './components/Support';
import { PurchasePopup } from './components/PurchasePopup';
import { CtaButton } from './components/CtaButton';
import { IMAGES, META_PIXEL_ID } from './lib/config';
import { useMetaPixel } from './lib/useMetaPixel';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <div className="relative min-h-full w-full bg-[#0b2431]" data-id="element-0" data-mp="28sl3gxardmez">
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: `url(${IMAGES.background})`,
      filter: 'blur(14px)',
      transform: 'scale(1.1)'
    }} data-id="element-1" data-mp="23w4drynwuzzs" />
      <div aria-hidden="true" className="fixed inset-0 z-0 bg-[#062331]/85" data-id="element-2" data-mp="3mj6ibtbzzuee" />

      <main className="relative z-10 mx-auto w-full max-w-md" data-id="element-3" data-mp="3relumgucxi8p">
        <Hero data-id="element-4" data-mp="4n725ibkvc5" />
        <GmailReviews data-id="element-5" data-mp="56lvdcob3ly" />
        <Problems data-id="element-6" data-mp="7sxpp6lk59z" />
        <Modules data-id="element-7" data-mp="2zllf11m4wkmq" />
        <Opinions data-id="element-8" data-mp="2zm4y4lnitf2c" />
        <Bonuses data-id="element-9" data-mp="2zmo557bmuj1l" />
        <CtaButton className="px-5" data-id="element-10" data-mp="2zn6actg9w7ln" />
        <Comparison data-id="element-11" data-mp="33m5be2yvvk7t" />
        <ClosingStatement data-id="element-12" data-mp="33nq6put0v76q" />
        <CtaButton className="px-5" data-id="element-13" data-mp="33mymth8sexwa" />
        <FinalOffer data-id="element-14" data-mp="38m1fs3bhtdnw" />
        <Objections data-id="element-15" data-mp="38li7zffk45nl" />
        <Support data-id="element-16" data-mp="38l06a3a4kz8a" />
      </main>

      <PurchasePopup data-id="element-17" data-mp="38o4gbha9up6v" />
    </div>;
}